export default __webpack_public_path__ + "675f647d01d3751a0113d305ce2baf8e.svg";